import { applyThemeWithLegacy } from "@evidenceb/athena-common/modules/Theme";
import axios from "axios";
import merge from "lodash/merge";
import { useContext, useMemo } from "react";
import { configStore } from "../contexts/ConfigContext";
import { sessionStore } from "../contexts/SessionContext";
import type {
  Application,
  ApplicationsConfig,
  Config,
} from "../interfaces/Config";
import useAssetsDetails from "./useAssetsDetails";

const useSelectApp = () => {
  const { config, setConfig } = useContext(configStore);
  const { setSession } = useContext(sessionStore);
  const fontAssetsDetails = useAssetsDetails();

  const selectApp = useMemo(
    () => async (app: Application, applicationsConfig?: ApplicationsConfig) => {
      const appOverrides: Partial<Config> = {
        client_name: app.client_name,
        lang: app.lang,
        declinaison: app.app,
      };
      let newMinimalconfig = {};
      if (config && (app.globalConfig || applicationsConfig?.globalConfig)) {
        const { data: minimalConfig } = await axios.get(
          `${config.apiUrls.endpoints.assetsProxy}${
            app.globalConfig || applicationsConfig?.globalConfig
          }`,
        );
        newMinimalconfig = minimalConfig.config;
        applyThemeWithLegacy({ fontAssetsDetails, ...minimalConfig.theme });
      }
      setConfig((config) =>
        merge(
          {},
          config,
          newMinimalconfig,
          applicationsConfig ?? {},
          appOverrides,
        ),
      );
      setSession((session) => ({
        ...session,
        app: app.app,
      }));
    },
    [config, setConfig, setSession, fontAssetsDetails],
  );

  return selectApp;
};

export default useSelectApp;
